interface SearchBarProps {
  /** Current query value (controlled) */
  value: string;
  /** Called when the user types */
  onChange: (query: string) => void;
  placeholder?: string;
  /** Extra class names on the wrapper */
  className?: string;
}

/**
 * Shared search input – controlled, auto-focus, styled for use inside
 * gradient headers or any container.  Toggle visibility from the parent.
 */
const SearchBar = ({
  value,
  onChange,
  placeholder = "Search…",
  className,
}: SearchBarProps) => (
  <div className={className}>
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      autoFocus
      className="w-full bg-white/15 text-white placeholder:text-white/40 rounded-xl px-4 py-2.5 text-sm font-dm-sans focus:outline-none focus:ring-2 focus:ring-white/30"
    />
  </div>
);

export default SearchBar;
